export interface IPopCardRowAutomationIds {
    row: string;
    dateRange: string;
    value: string;
    changeSuffix: string;
    bar: string;
}

export interface IPopCardAutomationIds {
    card: string;
    lockedCta: string;
    compared: IPopCardRowAutomationIds;
    current: IPopCardRowAutomationIds;
}

/**
 * Automation IDs are written out as literals so QA tests and codebase greps can
 * find them in source without reconstructing strings. Each row exposes IDs for
 * every visible element to support future E2E hooks even if the current spec
 * doesn't assert on all of them.
 */
export const CONVERTED_VISITS_AUTOMATION_IDS: IPopCardAutomationIds = {
    card: "conversion-rate-converted-visits-pop-card",
    lockedCta: "conversion-rate-converted-visits-pop-card-locked-cta",
    compared: {
        row: "conversion-rate-converted-visits-pop-card-compared-row",
        dateRange: "conversion-rate-converted-visits-pop-card-compared-date-range",
        value: "conversion-rate-converted-visits-pop-card-compared-value",
        changeSuffix: "conversion-rate-converted-visits-pop-card-compared-change-suffix",
        bar: "conversion-rate-converted-visits-pop-card-compared-bar",
    },
    current: {
        row: "conversion-rate-converted-visits-pop-card-current-row",
        dateRange: "conversion-rate-converted-visits-pop-card-current-date-range",
        value: "conversion-rate-converted-visits-pop-card-current-value",
        changeSuffix: "conversion-rate-converted-visits-pop-card-current-change-suffix",
        bar: "conversion-rate-converted-visits-pop-card-current-bar",
    },
};

export const AVG_RATE_AUTOMATION_IDS: IPopCardAutomationIds = {
    card: "conversion-rate-avg-rate-pop-card",
    lockedCta: "conversion-rate-avg-rate-pop-card-locked-cta",
    compared: {
        row: "conversion-rate-avg-rate-pop-card-compared-row",
        dateRange: "conversion-rate-avg-rate-pop-card-compared-date-range",
        value: "conversion-rate-avg-rate-pop-card-compared-value",
        changeSuffix: "conversion-rate-avg-rate-pop-card-compared-change-suffix",
        bar: "conversion-rate-avg-rate-pop-card-compared-bar",
    },
    current: {
        row: "conversion-rate-avg-rate-pop-card-current-row",
        dateRange: "conversion-rate-avg-rate-pop-card-current-date-range",
        value: "conversion-rate-avg-rate-pop-card-current-value",
        changeSuffix: "conversion-rate-avg-rate-pop-card-current-change-suffix",
        bar: "conversion-rate-avg-rate-pop-card-current-bar",
    },
};
